import { createContext } from 'react';

export type Mode = 'traditional' | 'water' | 'gamer';

export interface ModeContextValue {
  mode: Mode;
  setMode: (mode: Mode) => void;
  /** Liga `target` se ainda não estiver ativo, senão volta pra `traditional`. */
  toggle: (target: 'water' | 'gamer') => void;
}

export const ModeContext = createContext<ModeContextValue | null>(null);

export const MODE_STORAGE_KEY = 'portfolio-mode';
